const wa = (text) => `https://wa.me/919959089777?text=${encodeURIComponent(text)}`;

export const WA = {
    general: wa("Hello Saga Pan Palace! I visited your website and would like to know more about your paan varieties."),
    signature: wa("Hello Saga Pan Palace! I\u2019d like to know more about your signature paan collection. Could you please share the details?"),
    menu: wa("Hello Saga Pan Palace! I checked your menu and would like some more information about your paan varieties."),
    visit: wa("Hello Saga Pan Palace! I\u2019m planning to visit your store in Himayatnagar, Hyderabad. Could you please share the location and directions?"),
    party: wa("Hello Saga Pan Palace! I\u2019m interested in placing a party order. Could you please share the available options and details?"),
    contact: wa("Hello Saga Pan Palace! I\u2019d like to get in touch with your team regarding your products and services."),
    enquiry: ({ name, phone, message }) =>
        wa(`Hello Saga Pan Palace! I\u2019m ${name || "a guest"} from your website. ${message}${phone ? ` (You can reach me on ${phone}.)` : ""}`),
};

export const SITE = {
    name: "Paan Saga",
    location: "Himayatnagar · Hyderabad",
    tagline: "The Art of Paan, Reimagined.",
    subTagline: "For the love of Paan.",
    hours: "10:00 AM – 1:00 AM",
    tobaccoFree: "100% Tobacco Free",
    address: "Himayatnagar Main Road, Hyderabad, 500 029, Telangana",
    mapsUrl: "https://www.google.com/maps/dir/?api=1&destination=17.403694,78.482048",
    mapEmbed: "https://www.google.com/maps?q=17.403694,78.482048&hl=en&z=16&output=embed",
    phoneDisplay: "+91 99590 89777",
    phoneHref: "tel:+919959089777",
    email: "Paansagaindia@gmail.com",
    instagram: "https://www.instagram.com/paansagaindia",
    instagramHandle: "@paansagaindia",
    menuPdf: "/assets/saga-menu.pdf",
};
